import { getTermsValue, resetTerms, setTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { createTagValue } from '../../utils/createTagValue';
import { EBuildingCraneType } from '../../../../api-models/common/json_query';

const ID = 'buildingCranageTypesType' as const;

const CRANE_MAP_VALUE_TO_LABEL: Record<EBuildingCraneType, string> = {
  [EBuildingCraneType.Beam]: 'Кран-балка',
  [EBuildingCraneType.Goat]: 'Козловой кран',
  [EBuildingCraneType.Overhead]: 'Мостовой кран',
  [EBuildingCraneType.Railway]: 'Ж/д кран',
};

export const buildingCranageTypesTypeTagsManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const types = getTermsValue('building_cranage_types_type')(jsonQuery);

    if (types === null) {
      return null;
    }

    return types.map(t => ({
      label: CRANE_MAP_VALUE_TO_LABEL[t],
      value: createTagValue(ID, t.toString()),
    }));
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery, removingTagValue }) => {
    const types = getTermsValue('building_cranage_types_type')(jsonQuery);

    if (types === null) {
      return jsonQuery;
    }

    const next = types.filter(t => String(t) !== removingTagValue);

    return next.length > 0
      ? setTerms('building_cranage_types_type')(jsonQuery)(next)
      : resetTerms(['building_cranage_types_type'])(jsonQuery);
  },
};
